import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useHistory } from 'react-router-dom';
import Media from 'react-media';
import cn from 'classnames';

import { useUserState, useUserStateDispatch } from 'contexts/auth-context';
import { setIdAlert } from 'contexts/actions/authActions';
import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import { userState } from 'contexts/actions/authActions';

import {
  BtnGreenIconText,
  BtnDropCircle,
  BtnPurpleCircle,
  BtnPurple32,
  ModalWindow,
  BodyModalAlert,
  TooltipForElement,
  StatusTestUser
} from 'components/common/Elements/Elements';

import { getRequest, deleteRequest } from 'utils/requests';

import UserDropdown from '../../navigation/UserDropdown/UserDropdown';
import Logo from './parts/Logo/Logo';

import { downloadMenu } from 'data/dropDownConfig';

import classes from './MainHeader.module.scss';

const MainHeader = ({ onOfNotif, mixpanel }) => {
  const username = useUserState().user.username;

  const [modalAlert, setModalAlert] = useState(false);
  const [guestMode, setGuestMode] = useState(true);
  const [recentData, setRecentData] = useState([]);
  const [isChecked, setIsCheked] = useState();

  const language = useUserState().user.language;
  const isTrial = useUserState().user.trial;
  const error = useUserState().user.error;
  const alertInfo = useUserState().state.alertInfo;
  const dispatch = useUserStateDispatch();

  let location = useLocation();
  let history = useHistory();

  useEffect(() => {
    let params = location.pathname.split('/');
    setIsCheked(params[2]);

    const url = '/api/press-releases/recent';

    getRequest(url)
      .then(res => {
        setRecentData(res);
      })
      .catch(err => {
        console.log(err);
      });
    // eslint-disable-next-line
  }, [history.location.pathname]);

  useEffect(() => {
    const url = '/api/users/';

    getRequest(url)
      .then(res => {
        mixpanel.track(`User ${res[0].username} open App`);

        const error = undefined;

        userState({
          ...res[0],
          error
        })(dispatch);
      })
      .catch(err => {
        console.log(err);
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let params = location.pathname.split('/');
    if (params[1] === 'share') {
      setGuestMode(true);
    } else {
      setGuestMode(false);
    }
    // eslint-disable-next-line
  }, []);

  const handleNewRelease = () => {
    const url = '/api/users/';

    getRequest(url)
      .then(res => {
        const error = undefined;

        userState({
          ...res[0],
          error
        })(dispatch);

        const forGroupLimitReached = res[0].trial;
        const groupLimitReached = forGroupLimitReached
          ? forGroupLimitReached.groupLimitReached
          : null;

        trackingEvent('open_add_first_campaign', mixpanel, username);
        if (!groupLimitReached) {
          history.push(`/newrelease/first`);
        } else {
          userState({
            error: 400
          })(dispatch);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleAllGroups = () => {
    trackingEvent('go_to_group', mixpanel, username);
    history.push(`/groups`);
  };

  const onSelectOptionDownload = type => {
    trackingEvent(`download_${type}`, mixpanel, username);
    let params = location.pathname.split('/');
    let _id;
    let url;

    if (params[1] !== 'share') {
      if (params.length === 4) {
        _id = params[3];
      } else if (params.length === 3) {
        _id = params[2];
      }
    } else {
      if (params.length === 5) {
        _id = params[4];
      } else if (params.length === 4) {
        _id = params[3];
      }
    }

    if (params[1] !== 'share') {
      url =
        params.length === 4
          ? `/api/press-releases/action/${_id}/download/${type}`
          : `/api/press-release-groups/action/${_id}/download/${type}`;
    } else {
      url =
        params.length === 5
          ? `/api/press-releases/action/${_id}/download/${type}?share_token=${params[2]}`
          : `/api/press-release-groups/action/${_id}/download/${type}?share_token=${params[2]}`;
    }

    onOfNotif('on', t('notif', 'DOWNLOAD', language), true);
    getRequest(url)
      .then(res => {
        onOfNotif('off');
        window.open(`https://checkit.looqme.io:443${res.reportPath}`);
      })
      .catch(err => {
        onOfNotif('off');
        console.log(err);
      });
  };

  const onSelectLink = () => {
    trackingEvent('copy_link', mixpanel, username);
    let params = location.pathname.split('/');
    let _id;
    let url;

    if (params[1] !== 'share') {
      _id = params[2];
      url = `/api/press-releases/action/${_id}/share`;
      onOfNotif('on', t('notif', 'DOWNLOAD', language), true);
      getRequest(url)
        .then(res => {
          onOfNotif('off');
          const link =
            params.length === 4
              ? `https://checkit.looqme.io/share/${res.shareToken}/${params[2]}/${params[3]}`
              : `https://checkit.looqme.io/share/${res.shareToken}/${params[2]}`;

          navigator.clipboard
            .writeText(link)
            .then(() => {
              onOfNotif('on', t('notif', 'COPY_LINK', language), false, '2000');
            })
            .catch(err => console.log(err));
        })
        .catch(err => {
          onOfNotif('off');
          console.log(err);
        });
    } else {
      _id = params[3];

      navigator.clipboard
        .writeText(`https://checkit.looqme.io${location.pathname}`)
        .then(() => {
          onOfNotif('on', t('notif', 'COPY_LINK', language), false, '2000');
        })
        .catch(err => console.log(err));
    }
  };

  const onAlert = () => {
    trackingEvent('open_receive_notif', mixpanel, username);
    setModalAlert(true);
  };

  const ofAlert = () => {
    trackingEvent('receive_notif_off', mixpanel, username);

    deleteRequest(`/api/press-release-alertsettings/${alertInfo.id}/`)
      .then(() => {
        setIdAlert({
          title: alertInfo.title,
          id: null,
          groupId: alertInfo.groupId
        })(dispatch);
      })
      .catch(err => {
        console.log(err);
      });
  };

  if (location.pathname.indexOf('login') !== -1) {
    return <></>;
  }

  if (location.pathname.indexOf('password-reset') !== -1) {
    return <></>;
  }

  const validationShowDownload = () => {
    const locationInfo = location.pathname.split('/');

    if (locationInfo.length >= 3) {
      if (locationInfo[2] !== 'first' && locationInfo[2] !== 'deleted') {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };

  return (
    <div className={classes.headerContainer}>
      {isTrial && !guestMode && (
        <StatusTestUser
          dayToFinish={isTrial.daysLeft}
          errorCode={error}
          mixpanel={mixpanel}
        />
      )}

      <header className={classes.header}>
        {alertInfo && (
          <ModalWindow
            headerText={t('groupsRelease', 'RECEIVE_NOTIF', language)}
            isOpen={modalAlert}
            setIsOpen={() => {
              trackingEvent('cancel_receive_notif', mixpanel, username);
              setModalAlert(false);
            }}
            stylesModal={{ body: classes.modalAlertmobile }}
          >
            <BodyModalAlert
              submit={e => {
                setIdAlert({
                  title: alertInfo.title,
                  id: e.id,
                  groupId: alertInfo.groupId
                })(dispatch);
              }}
              onCancel={() => setModalAlert(false)}
              name={alertInfo.title}
              id={alertInfo.groupId}
              mixpanel={mixpanel}
              onOfNotif={onOfNotif}
            />
          </ModalWindow>
        )}

        <div className={classes.wrapRowHeader}>
          <Logo className={classes.logo} guestMode={guestMode} />
          <div className={classes.menu}>
            <div
              className={cn(
                classes.exportBtnBox,
                !guestMode && classes.exportBtnBox_margin
              )}
            >
              <Media
                queries={{
                  small: '(max-width: 1279px)'
                }}
              >
                {matches => (
                  <>
                    {validationShowDownload() && !guestMode && (
                      <TooltipForElement
                        text={
                          alertInfo && alertInfo.id
                            ? t('tooltip', 'UNSUBSCRIBE', language)
                            : t('tooltip', 'RECEIVE_NOTIFICATION', language)
                        }
                        className={classes.exportBtn}
                        isOpen={matches.small ? false : undefined}
                      >
                        <BtnPurpleCircle
                          icon={
                            alertInfo && alertInfo.id
                              ? 'Icn_Subscribe1'
                              : 'Icn_Subscribe'
                          }
                          onClick={
                            alertInfo && alertInfo.id ? ofAlert : onAlert
                          }
                        />
                      </TooltipForElement>
                    )}
                  </>
                )}
              </Media>

              {validationShowDownload() && (
                <>
                  <BtnDropCircle
                    icon={'Icn_Download'}
                    className={classes.exportBtn}
                    menuConfig={downloadMenu}
                    selectOption={onSelectOptionDownload}
                  />
                  <BtnDropCircle
                    icon={'Icn_Share'}
                    className={classes.exportBtn}
                    selectOption={onSelectLink}
                    body={'Поделиться'}
                    rightDrop={guestMode}
                  />
                </>
              )}
            </div>

            <Media
              queries={{
                large: '(min-width: 700px)'
              }}
            >
              {matches => (
                <>
                  {matches.large && !guestMode && (
                    <div className={classes.releaseBtnBox}>
                      <BtnGreenIconText
                        onClick={handleNewRelease}
                        textButton={t('mainHeader', 'CREATE_NEW', language)}
                        icon={'Icn_Add'}
                      />
                      <BtnPurple32
                        onClick={handleAllGroups}
                        textButton={t('mainHeader', 'ALL_RELEASES', language)}
                        className={classes.btnAllRelease}
                        recentData={recentData}
                        isChecked={isChecked}
                        onCreate={handleNewRelease}
                        mixpanel={mixpanel}
                      />
                    </div>
                  )}
                </>
              )}
            </Media>
            {!guestMode && (
              <>
                <a
                  // eslint-disable-next-line
                  target="_blank"
                  href={
                    language === 'uk'
                      ? 'https://drive.google.com/file/d/1dbnVDP9OzpnonRHBgv7RdP7LSUatC-PP/view?usp=sharing'
                      : language === 'en'
                      ? 'https://drive.google.com/file/d/1_QdsrdPQGSZwNvgIdJym5oNM0z6M13j8/view?usp=sharing'
                      : 'https://drive.google.com/file/d/16nwC6oZTqIfGx8zZ12X4AAWM1BZvd82I/view?usp=sharing'
                  }
                >
                  <BtnPurpleCircle
                    icon={'Icn_Help'}
                    className={classes.helpBtn}
                  />
                </a>

                <UserDropdown className={classes.userBtn} mixpanel={mixpanel} />
              </>
            )}
          </div>
        </div>
        <Media
          queries={{
            large: '(max-width: 699px)'
          }}
        >
          {matches => (
            <>
              {matches.large && !guestMode && (
                <div className={classes.wrapRowTooHeader}>
                  <BtnPurple32
                    onClick={handleAllGroups}
                    textButton={t('mainHeader', 'ALL_RELEASES', language)}
                    recentData={recentData}
                    isChecked={isChecked}
                    onCreate={handleNewRelease}
                    mixpanel={mixpanel}
                  />
                  <BtnGreenIconText
                    className={classes.mobileBtnGreen}
                    onClick={handleNewRelease}
                    textButton={t('mainHeader', 'CREATE_NEW', language)}
                    icon={'Icn_Add'}
                  />
                </div>
              )}
            </>
          )}
        </Media>
      </header>
    </div>
  );
};

MainHeader.propTypes = {
  onOfNotif: PropTypes.func,
  mixpanel: PropTypes.object
};

export default MainHeader;
